import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentGql } from './DatasourcesDisplayGridRowDataFragmentGql';

export const TableUpstreamDatasourcesFilteredByColumnQueryGql: DocumentNode = gql`
query TableUpstreamDatasourcesFilteredByColumnQuery(
  $tableId: ID!,
  $columnId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: PublishedDatasourceSortOrder!
) {
  tables(filter: { id: $tableId }) {
    columns(filter: { id: $columnId }) {
      upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatasourcesDisplayGridRowDataFragment
        }
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentGql}
`;
